import { makeStyles } from '@mui/styles'
import React from 'react'
import ThemeInterface from '@/theme-interface'
import TenantInitialsBubble from '@/modules/my-account/tenant-information/tenant-initials-bubble'
import { useAppSelector } from '@/redux/store'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  root: {
    display: 'flex',
    gap: 10,
    alignSelf: 'flex-end',
    alignItems: 'flex-end',
    maxWidth: '85%',
  },
  message: {
    border: theme.border,
    borderRadius: 30,
    borderBottomRightRadius: 0,
    padding: '12px 16px',
    backgroundColor: theme.white,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
}))

export default function AiChatBubble(props: { message: string }) {
  const classes = useStyles()
  const { message } = props

  const activeTenant = useAppSelector(state => state.user.info.activeTenant)
  const avatarImageUrl = useSelector(state => state.user.info.avatarImageUrl)
  const firstName = useAppSelector(state => state.user.info.firstName)
  const lastName = useAppSelector(state => state.user.info.lastName)
  const {
    tenantName,
    companyName,
    backgroundColor,
    color,
  } = activeTenant

  return (
    <div className={classes.root}>
      <div className={classes.message}>
        {message}
      </div>
      <TenantInitialsBubble
        iconColors={{ backgroundColor, color }}
        tenantName={[firstName, lastName].join(' ').trim() || tenantName}
        companyName={companyName}
        avatarUrl={avatarImageUrl}
        iconSize={25}
        minIconSize={25}
      />
    </div>
  )
}
